<template>
  <div id="sidebar" class="ui sidebar vertical labeled menu">
    <div class="item" v-for="menu in sidebarMenus()" v-bind:key="menu.id">
      <b>{{ menu.title }}</b>
      <div class="menu" v-if="hasSubMenus(menu)">
        <template v-for="child in menu.subMenus">
          <router-link class="item" v-if="child.route" v-bind:key="child.id" :to="child.route">
            <i :class="child.icon"></i>
            {{ child.title }}
          </router-link>
          <!-- <template v-else>
            <b v-bind:key="child.id">{{ menu.title }}</b>
            <div class="menu" v-if="hasSubMenus(child.child)" v-bind:key="child.id">
              <router-link
                class="item"
                v-for="childItems in child.child"
                v-bind:key="childItems.id"
                :to="childItems.route"
              >
                <i :class="childItems.icon"></i>
                {{ childItems.title }}
              </router-link>
            </div>
          </template> -->

          <!-- <div v-else class="ui vertical menu" v-bind:key="child.id">
            <div class="ui dropdown item">
              {{child.title}}
              <i class="dropdown icon"></i>
              <div class="menu" v-if="child.child">
                <router-link
                  v-for="subChild in child.child"
                  class="item"
                  v-bind:key="subChild.id"
                  :to="subChild.route"
                >{{ subChild.title }}</router-link>
              </div>
            </div>
          </div>-->
        </template>
      </div>
    </div>
  </div>
</template>

<script>
// import permissionMixins from '@/mixins/permissions';

export default {
  name: "Sidebar",
  computed: {
    userMenus() {
      //   const menus = this.sidebarMenus();
      //   let userMenus = menus.map(menu => {
      //     if (this.has(menu.permission)) {
      //       const parent = menu;
      //       if (parent.subMenus.length) {
      //         let childMenus = parent.subMenus.map(cMenu =>
      //           this.has(cMenu.permission) ? cMenu : []
      //         );
      //         // Removing empty subMenus
      //         childMenus = this.uniqueArray(childMenus);
      //         parent.subMenus = childMenus;
      //         return parent;
      //       }
      //     }
      //     return [];
      //   });
      // Removing empty subMenus
      //   menus = this.uniqueArray(menus);
      //   return menus;
    }
  },
  methods: {
    hasSubMenus(menu) {
      return menu.subMenus.length;
    },
    uniqueArray(arr) {
      const filteredArr = arr.filter(value => {
        if (Array.isArray(value)) {
          return value.length;
        }
        if (value instanceof String) {
          return value !== "";
        }
        if (value instanceof Object) {
          return value !== {};
        }
        return false;
      });

      return filteredArr;
    },
    sidebarMenus() {
      return [
        {
          id: 1,
          title: "Admin Dashboard",
          subMenus: [
            {
              route: "/",
              title: "Home",
              icon: "home icon"
            },
            {
              route: "contracts",
              title: "Contracts",
              icon: "file alternate icon"
			},
			{
                  route: "fees",
				  title: "Contract Fees",
				  icon: "money bill alternate icon"
			},
			{
                  route: "acc_fees",
				  title: "Account Fees",
				  icon: "money bill alternate icon"
			}
			
            // {
            //   //   route: 'fee',
            //   title: "Fees",
            //   icon: "money bill alternate icon",
            //   child: [
            //     {
            //       route: "fees",
            //       title: "Contract Fees"
            //     },
            //     {
            //       route: "acc_fees",
            //       title: "Account Fees"
            //     }
            //   ]
            // }
          ]
        }
      ];
    }
  }
};
</script>
